import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LecturerDashboard from './pages/LecturerDashboard';
import LecturerUnits from './pages/LecturerUnits';
import Units from './pages/Units';
import UnitDetails from './pages/UnitDetails';
import Assignments from './pages/Assignments';
import Profile from './pages/Profile';
import LearningMaterials from './pages/LearningMaterials';
import Quiz from './pages/Quiz';
import Payment from './pages/Payment';
import NotFound from './pages/NotFound';
import InstitutionSelection from './pages/InstitutionSelection';
import Landing from './pages/Landing';
import Signup from './pages/Signup';
import Pricing from './pages/Pricing';
import InstitutionSignup from './pages/InstitutionSignup';
import VirtualClassPage from './pages/VirtualClassPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route
            path="/select-institution"
            element={
              <ProtectedRoute requireAuth={false}>
                <InstitutionSelection />
              </ProtectedRoute>
            }
          />

          <Route
            path="/landing"
            element={
              <ProtectedRoute requireAuth={false}>
                <Landing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/login"
            element={
              <ProtectedRoute requireAuth={false}>
                <Login />
              </ProtectedRoute>
            }
          />

          <Route
            path="/register"
            element={
              <ProtectedRoute requireAuth={false}>
                <Signup />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pricing"
            element={
              <ProtectedRoute requireAuth={false}>
                <Pricing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/institution/signup"
            element={
              <ProtectedRoute requireAuth={false}>
                <InstitutionSignup />
              </ProtectedRoute>
            }
          />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/lecturer-dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <LecturerDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/units"
            element={
              <ProtectedRoute>
                <Layout>
                  <Units />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/lecturer-units"
            element={
              <ProtectedRoute>
                <Layout>
                  <LecturerUnits />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/units/:unitId"
            element={
              <ProtectedRoute>
                <Layout>
                  <UnitDetails />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/assignments"
            element={
              <ProtectedRoute>
                <Layout>
                  <Assignments />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/payment/:unitId"
            element={
              <ProtectedRoute>
                <Layout>
                  <Payment />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/materials"
            element={
              <ProtectedRoute>
                <Layout>
                  <LearningMaterials />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/learning-materials"
            element={
              <ProtectedRoute>
                <Layout>
                  <LearningMaterials />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quiz/:quizId"
            element={
              <ProtectedRoute>
                <Layout>
                  <Quiz />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/virtual-classroom"
            element={
              <ProtectedRoute>
                <Layout>
                  <VirtualClassPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Redirect root to institution selection */}
          <Route path="/" element={<Navigate to="/select-institution" replace />} />

          {/* 404 page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
